<template>
  <router-link :to="{ name: to }" tag="a" class="nav-link">
    {{ title }}
  </router-link>
</template>

<script>
export default {
  props: {
    to: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
};
</script>
